/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} A11y_Statement_IntroInputs */

const en_a11y_statement_intro = /** @type {(inputs: A11y_Statement_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema (alchema.eu) strives to make its web application accessible in accordance with the German Accessibility Strengthening Act (BFSG) and the European standard EN 301 549.`)
};

const de_a11y_statement_intro = /** @type {(inputs: A11y_Statement_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema (alchema.eu) ist bestrebt, seine Webanwendung im Einklang mit dem Barrierefreiheitsstärkungsgesetz (BFSG) und der europäischen Norm EN 301 549 barrierefrei zugänglich zu machen.`)
};

const fr_a11y_statement_intro = /** @type {(inputs: A11y_Statement_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema (alchema.eu) s'efforce de rendre son application web accessible conformement a la loi allemande sur le renforcement de l'accessibilite (BFSG) et a la norme europeenne EN 301 549.`)
};

const es_a11y_statement_intro = /** @type {(inputs: A11y_Statement_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema (alchema.eu) se esfuerza por hacer su aplicacion web accesible de acuerdo con la Ley alemana de fortalecimiento de la accesibilidad (BFSG) y la norma europea EN 301 549.`)
};

const it_a11y_statement_intro = /** @type {(inputs: A11y_Statement_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema (alchema.eu) si impegna a rendere la sua applicazione web accessibile in conformita con la legge tedesca sul rafforzamento dell'accessibilita (BFSG) e lo standard europeo EN 301 549.`)
};

const nl_a11y_statement_intro = /** @type {(inputs: A11y_Statement_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema (alchema.eu) streeft ernaar zijn webapplicatie toegankelijk te maken in overeenstemming met de Duitse wet op de versterking van de toegankelijkheid (BFSG) en de Europese norm EN 301 549.`)
};

const pl_a11y_statement_intro = /** @type {(inputs: A11y_Statement_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema (alchema.eu) stara sie zapewnic dostepnosc swojej aplikacji internetowej zgodnie z niemiecka ustawa o wzmocnieniu dostepnosci (BFSG) i norma europejska EN 301 549.`)
};

const fi_a11y_statement_intro = /** @type {(inputs: A11y_Statement_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema (alchema.eu) pyrkii tekemään verkkosovelluksestaan saavutettavan Saksan esteettömyyslain (BFSG) ja eurooppalaisen standardin EN 301 549 mukaisesti.`)
};

const da_a11y_statement_intro = /** @type {(inputs: A11y_Statement_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema (alchema.eu) bestrasber sig pa at gore sin webapplikation tilgaengelig i overensstemmelse med den tyske lov om staerket tilgaengelighed (BFSG) og den europaeiske standard EN 301 549.`)
};

const sv_a11y_statement_intro = /** @type {(inputs: A11y_Statement_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alchema (alchema.eu) stravar efter att gora sin webbapplikation tillganglig i enlighet med den tyska lagen om starkt tillganglighet (BFSG) och den europeiska standarden EN 301 549.`)
};

/**
* | output |
* | --- |
* | "Alchema (alchema.eu) strives to make its web application accessible in accordance with the German Accessibility Strengthening Act (BFSG) and the European sta..." |
*
* @param {A11y_Statement_IntroInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const a11y_statement_intro = /** @type {((inputs?: A11y_Statement_IntroInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<A11y_Statement_IntroInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_a11y_statement_intro(inputs)
	if (locale === "fr") return fr_a11y_statement_intro(inputs)
	if (locale === "es") return es_a11y_statement_intro(inputs)
	if (locale === "it") return it_a11y_statement_intro(inputs)
	if (locale === "nl") return nl_a11y_statement_intro(inputs)
	if (locale === "pl") return pl_a11y_statement_intro(inputs)
	if (locale === "fi") return fi_a11y_statement_intro(inputs)
	if (locale === "da") return da_a11y_statement_intro(inputs)
	if (locale === "sv") return sv_a11y_statement_intro(inputs)
	return en_a11y_statement_intro(inputs)
});